module.exports = __webpack_public_path__ + "static/img/ecmedia.a7269c0b.png";